import { ElementRef, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericGridComponent } from '../../../common/components/generic-grid/generic-grid.component';
import { LoadingService } from '../../../common/components/loading/loading.service';
import { AlertifyService } from '../../../home/components/service-pay/common/services/alertify.service';
import { CurrencyVM } from '../../../models/view-models';
import { CurrencyService } from '../../../services/currency.service';

@Component({
  selector: 'app-currencies',
  templateUrl: './currencies.component.html',
  styleUrls: ['./currencies.component.scss']
})
export class CurrenciesComponent implements OnInit {

  data: CurrencyVM[] = [];
  currency!: CurrencyVM;
  entityForm!: FormGroup;
  isEdition: boolean = false;
  showForm: boolean = false;

  @ViewChild("grid", { read: GenericGridComponent })
  public grid: GenericGridComponent;

  @ViewChild("code") code: ElementRef;
  @ViewChild("name") name: ElementRef;

  constructor(private CurrencyService: CurrencyService,
    private fb: FormBuilder,
    private alertify: AlertifyService,
    private loading: LoadingService) { }


  ngOnInit(): void {
    this.loadData();
    this.initForm();
  }

  initForm() {
    this.entityForm = this.fb.group({
      Code: ['', [Validators.required]],
      Name: ['', [Validators.required]],
      Symbol: ['', [Validators.required]],
      Exchange: [0, [Validators.required]],
      Description: [''],
    });
  }

  isValidForm(): boolean {
    return this.entityForm.valid;
  }

  loadData() {
    this.loading.show();
    this.CurrencyService.getAll()
      .subscribe((response: CurrencyVM[]) => {
        if (response) {
          this.data = response;
        }
        this.setGridOptions();
        this.loading.hide();
      });
  }

  setGridOptions() {
    this.grid.setData(this.data);
    this.grid.options.toolbarTitle = "Monedas";
    this.grid.options.showDetailsButton = false;
    this.grid.columns = [
      { field: "Symbol", title: "Símbolo", cssClass: "text-center" },
      { field: "Code", title: "Código" },
      { field: "Name", title: "Nombre" },
      { field: "Exchange", title: "Tipo de cambio", currencyType: true },
    ];
    this.grid.setGridOptions();
  }

  setFormVisibility = () => this.showForm = !this.showForm;

  focusOnCodeInput= () => setTimeout(() => {
    this.code.nativeElement.focus();
  }, 0);

  focusOnNameInput = () => setTimeout(() => {
    this.name.nativeElement.focus();
    this.name.nativeElement.select();
  }, 0);

  addNew() {
    this.isEdition = false;
    this.setFormVisibility();
    this.focusOnCodeInput();
  }

  save() {
    if (this.isValidForm()) {
      this.loading.show();
      this.CurrencyService.insert(this.entityForm.value)
        .subscribe((response: CurrencyVM) => {
          if (response) {
            this.grid.addRow(response);
          }
          this.cancel();
          this.loading.hide();
        });
    }
  }

  edit(value: CurrencyVM) {
    this.currency = value;
    this.entityForm.setValue({
      Code: this.currency.Code,
      Name: this.currency.Name,
      Symbol: this.currency.Symbol,
      Exchange: this.currency.Exchange,
      Description: this.currency.Description,
    });
    this.isEdition = true;
    this.setFormVisibility();
    this.focusOnNameInput();
  }

  update() {
    if (this.isValidForm()) {
      this.loading.show();
      this.CurrencyService.update(Object.assign({
        UUID: this.currency.UUID
      }, this.entityForm.value))
        .subscribe((response: CurrencyVM) => {
          if (response) {
            this.grid.updateRowByUUID(response);
            this.cancel();
          }
          this.loading.hide();
        });
    }
  }

  delete(value: CurrencyVM) {
    this.alertify.confirm(
      `Eliminar moneda: ${value.Name}`,
      () => {
        this.loading.show();
        this.CurrencyService.delete(value.UUID)
          .subscribe((response: boolean) => {
            if (response) {
              this.grid.deleteRow(value.UUID);
            }
            this.loading.hide();
          });
      });
  }

  cancel() {
    this.setFormVisibility();
    this.entityForm.reset();
    this.isEdition = false;
  }

}
